import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
} from 'react';
import { Form, Input, Spin, Row, Col, Skeleton, Button } from 'antd';
import classnames from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
import Email from '@/components/H5PC/Form/Email';
import Phone from '@/components/H5PC/Form/Phone'
import getTypeByPattern from '@/components/Common/getTypeByPattern.js';
import { infoCb } from '@/service';
import _ from 'lodash';
import NodeRSA from 'node-rsa';
import CPF from '@/components/H5PC/Components/CPF';
import { getDomainFromUrlStr, getDomainStr } from '@/components/H5PC/utils'
import myContext from '@/utils/createContext';
import { getUrlParams, gtag } from '@/utils/index.js';
import Address from '@/components/H5PC/Form/Address';
import allRegex from '@/components/allRegex.js';


const FormItem = Form.Item;

const key = getUrlParams('key'); // 从 URL 中获取 key

function KPAY(props) {
  const nameOnCardFirstRef = useRef();
  const nameOnCardLastRef = useRef();

  const addressRef = useRef();
  const intl = props.intl;
  const { formatMessage } = intl;
  // radioValue 即为LCR 或者 ICR
  const { form, initData, resData, radioValue, isMobileView, loading, actualPaymentAmount, actualPaymentCurrency } = useContext(
    myContext,
  );
  let showDomain = '';

  if(typeof window!= 'undefined' && getDomainFromUrlStr()){
    showDomain = getDomainStr(resData)
  }
  const h5OrWeb = isMobileView ? 'H5' : 'WEB';
  let [activeLoading, setActiveLoading] = useState(true);
  useEffect(() => {
    if (!_.isEmpty(initData)) {
      setTimeout(() => {
        setActiveLoading(false);
      }, 500);
    }
  }, [initData]);
  const onBlurCarFirstName = async function(e) {
    // todo @埋点
    gtag(`${showDomain}支付页面`, [new Date() + '输入持卡人FirstName']);
    gtag(`${showDomain}支付页面`, ['输入持卡人FirstName']);
    showDomain ? gtag(`定制支付页面`, ['输入持卡人FirstName']):'';

    

  };
  const onBlurCardLastName = async function(e) {
    // todo @埋点
    gtag(`${showDomain}支付页面`, [new Date() + '输入持卡人LastName']);
    gtag(`${showDomain}支付页面`, ['输入持卡人LastName']);
    showDomain ? gtag(`定制支付页面`, ['输入持卡人LastName']):'';

  };
  // todo 111，专门传递address组件中的信息而存在的
  // useImperativeHandle(props.cref, () => ({
  //   // 动态改变label的值
  //   clickEdit: () => {
  //     setAddressChange(addressRef);
  //   },
  // }));

  // 表单验证错误，弹出地址选择信息
  const setAddressChange = cref => {
    if (!_.isEmpty(cref.current)) {
      cref.current.clickEdit();
    }
  };
  // todo 222，专门传递address组件中的信息而存在的

  return (
    <Skeleton
      loading={activeLoading}
      active={true}
      title={false}
      // style={{ padding: 100 }}
      paragraph={{ rows: 7 }}
    >
      {radioValue === 'KON' || radioValue === 'PEZ' || radioValue === 'AFTERPAY'? (
        <>
          <Row gutter={20} style={{ marginBottom: '10px', padding: '0 15px' }}>
            <Col span={12} style={{paddingRight: '5px'}}>
              <FloatLabel
                form={form}
                name="firstName"
                cref={nameOnCardFirstRef}
                // label="Full Name"
                label={formatMessage({ id: 'ga-checkout.first-name' })}
                rules={[
                  {
                    required: true,
                    // message: `Please enter your full name.`,
                    message: formatMessage({
                      id: 'ga-checkout.please-enter-first-name',
                    }),
                  },
                  {
                    pattern: allRegex.jaNameReg,
                    // message: 'Please enter correct email address.',
                    message: formatMessage({
                      id: 'ga-checkout.first-name-has-space',
                    }),
                  },
                ]}
              >
                <Input
                  size="large"
                  maxLength={128}
                  onBlur={e => onBlurCarFirstName(e)}
                />
              </FloatLabel>
            </Col>
            <Col span={12} style={{paddingLeft: '5px'}}>
            <FloatLabel
                form={form}
                name="lastName"
                cref={nameOnCardLastRef}
                // label="Full Name"
                label={formatMessage({ id: 'ga-checkout.last-name' })}
                rules={[
                  {
                    required: true,
                    // message: `Please enter your full name.`,
                    message: formatMessage({
                      id: 'ga-checkout.please-enter-last-name',
                    }),
                  },
                  {
                    pattern: allRegex.jaNameReg,
                    // message: 'Please enter correct email address.',
                    message: formatMessage({
                      id: 'ga-checkout.last-name-has-space',
                    }),
                  },
                ]}
              >
                <Input
                  size="large"
                  maxLength={128}
                  onBlur={e => onBlurCardLastName(e)}
                />
              </FloatLabel>
            </Col>
          </Row>

          <myContext.Provider value={{ form, initData, isMobileView, showDomain }}>
            <Email />
          </myContext.Provider>

          <myContext.Provider value={{ form, initData, isMobileView, showDomain}}>
            <Phone />
          </myContext.Provider>
          <div className="h5pc-submit">
            <Button
              className="h5pc-submit-btn"
              type="primary"
              htmlType="submit"
              loading={loading}
            >

              <span className="lock-img" ></span>
              {formatMessage({ id: 'ga-checkout.pay' })} &nbsp;
              {actualPaymentAmount} {actualPaymentCurrency}
            </Button>
          </div>
        </>
      ) : null}
    </Skeleton>
  );
}

export default injectIntl(KPAY);
